// AUTO-GENERATED FILE — do not edit by hand.
// Regenerate with `pnpm --filter ./apps/web gen:permissions`.
// Sources: libs/permissions/src/enums/permission.enum.ts
//          libs/permissions/src/metadata/permission-metadata.ts
//          libs/permissions/src/metadata/permission-groups.ts

export const Permission = {
  UserAdminView: 'UserAdminView',
  UserAdminManage: 'UserAdminManage',
  UserSuspend: 'UserSuspend',
  UserUpdateKycStatus: 'UserUpdateKycStatus',
  EntityView: 'EntityView',
  EntityViewFinancials: 'EntityViewFinancials',
  EntityManageProfile: 'EntityManageProfile',
  EntityManageTeam: 'EntityManageTeam',
  EntityAdminView: 'EntityAdminView',
  EntityReview: 'EntityReview',
  EntityManageProviderStatus: 'EntityManageProviderStatus',
  EntityDelete: 'EntityDelete',
  ResendInvitations: 'ResendInvitations',
  EntityUpdateSensitiveInfo: 'EntityUpdateSensitiveInfo',
  EntityBypassUpdateApproval: 'EntityBypassUpdateApproval',
  FundBypassUpdateApproval: 'FundBypassUpdateApproval',
  GammaBypassAllUpdateApproval: 'GammaBypassAllUpdateApproval',
  EntityViewRoles: 'EntityViewRoles',
  EntityManageRoles: 'EntityManageRoles',
  EntityAssignRoles: 'EntityAssignRoles',
  GammaViewRoles: 'GammaViewRoles',
  GammaManageRoles: 'GammaManageRoles',
  GammaAssignRoles: 'GammaAssignRoles',
  EntityApproveRoleRequests: 'EntityApproveRoleRequests',
  GammaApproveRoleRequests: 'GammaApproveRoleRequests',
  FundView: 'FundView',
  FundManage: 'FundManage',
  FundManageTeam: 'FundManageTeam',
  FundAdminView: 'FundAdminView',
  FundReview: 'FundReview',
  FundDelete: 'FundDelete',
  FundCloseFund: 'FundCloseFund',
  NoteModerate: 'NoteModerate',
  NoteViewGammaInternal: 'NoteViewGammaInternal',
  FundUpdateName: 'FundUpdateName',
  FundEditLive: 'FundEditLive',
  InvestorViewCompliance: 'InvestorViewCompliance',
  GlobalAdminCrossEntityAccess: 'GlobalAdminCrossEntityAccess',
  ReferralAdminView: 'ReferralAdminView',
  ReferralAdminManage: 'ReferralAdminManage',
  ReferralFeeReports: 'ReferralFeeReports',
  ChatView: 'ChatView',
  ChatParticipate: 'ChatParticipate',
  ChatViewAllTopics: 'ChatViewAllTopics',
  ChatSendAsGammaDesk: 'ChatSendAsGammaDesk',
  ChatModerateMessages: 'ChatModerateMessages',
  ViewAndManageGammaEvents: 'ViewAndManageGammaEvents',
  ViewAndManageOwnEvents: 'ViewAndManageOwnEvents',
  GammaManageEventsAccess: 'GammaManageEventsAccess',
  GammaTeamView: 'GammaTeamView',
  GammaTeamManage: 'GammaTeamManage',
  GammaTeamAssignSuperAdmin: 'GammaTeamAssignSuperAdmin',
  AdminConsoleView: 'AdminConsoleView',
  AdminTeamActivityView: 'AdminTeamActivityView',
  AdminTeamActivityManage: 'AdminTeamActivityManage',
  AdminMaintenance: 'AdminMaintenance',
  SigningDocumentsView: 'SigningDocumentsView',
  SigningDocumentsManage: 'SigningDocumentsManage',
  InvestmentSubscriptionManageOwn: 'InvestmentSubscriptionManageOwn',
  InternalLookup: 'InternalLookup',
  DealManage: 'DealManage',
  DealDelete: 'DealDelete',
  DealAdminView: 'DealAdminView',
  DealAdminManage: 'DealAdminManage',
  AddressBookView: 'AddressBookView',
  AddressBookManage: 'AddressBookManage',
  AddressBookViewAllCategories: 'AddressBookViewAllCategories',
  AddressBookReadAnyContacts: 'AddressBookReadAnyContacts',
  KanbanItemView: 'KanbanItemView',
  KanbanManage: 'KanbanManage',
  KanbanAdmin: 'KanbanAdmin',
  EntityInvestmentBoard: 'EntityInvestmentBoard',
  ContactImport: 'ContactImport',
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];

export const PERMISSION_GROUPS = {
  entity: { label: 'Entity', order: 1 },
  funds: { label: 'Funds', order: 2 },
  investing: { label: 'Investors & portfolio', order: 3 },
  deals: { label: 'Deals', order: 4 },
  chat: { label: 'Communications', order: 5 },
  'address-book': { label: 'Address book', order: 6 },
  events: { label: 'Events', order: 7 },
  referral: { label: 'Referrals', order: 8 },
  users: { label: 'Users', order: 9 },
  'gamma-team': { label: 'Gamma team & roles', order: 10 },
  roles: { label: 'Roles & permissions', order: 11 },
  admin: { label: 'Platform administration', order: 12 },
  'approval-bypass': { label: 'Approval bypass', order: 13 },
} as const;

export type PermissionGroupKey = keyof typeof PERMISSION_GROUPS;

export type PermissionMetadata = {
  label: string;
  description: string;
  group: PermissionGroupKey;
  plane: 'entity' | 'gamma';
  sensitive: boolean;
  /** No role-administration flow may add it to a role, so neither plane's catalogue offers it. */
  gammaAssignedOnly?: true;
};

export const PERMISSION_METADATA: Record<Permission, PermissionMetadata> = {
  UserAdminView: {
    label: 'View users as Gamma',
    description:
      "Lets the holder view the full platform user list and any user's profile, questionnaire, KYC status, transactions and file actions.",
    group: 'users',
    plane: 'gamma',
    sensitive: false,
  },
  UserAdminManage: {
    label: 'Manage users as Gamma',
    description:
      "Lets the holder edit another user's profile fields, their tags, and their demo flag.",
    group: 'users',
    plane: 'gamma',
    sensitive: false,
  },
  UserSuspend: {
    label: 'Suspend a user account',
    description: "Lets the holder block, unblock or delete a user's account.",
    group: 'users',
    plane: 'gamma',
    sensitive: false,
  },
  UserUpdateKycStatus: {
    label: "Update a user's KYC status",
    description:
      "Lets the holder set the result of a user's identity (KYC) check from their profile.",
    group: 'users',
    plane: 'gamma',
    sensitive: false,
  },
  EntityView: {
    label: 'View an entity',
    description:
      'Lets the holder view an entity, its team members and their profiles and documents.',
    group: 'entity',
    plane: 'entity',
    sensitive: false,
  },
  EntityViewFinancials: {
    label: 'View entity financials',
    description:
      "Lets the holder view an entity's investors, transactions and portfolio performance.",
    group: 'investing',
    plane: 'entity',
    sensitive: false,
  },
  EntityManageProfile: {
    label: 'Manage an entity profile',
    description:
      "Lets the holder edit an entity's details, verifications and directors, rename its files, and submit it for review.",
    group: 'entity',
    plane: 'entity',
    sensitive: false,
  },
  EntityManageTeam: {
    label: 'Manage an entity team',
    description:
      "Lets the holder invite, edit and remove an entity's members and their invitations.",
    group: 'entity',
    plane: 'entity',
    sensitive: false,
  },
  EntityAdminView: {
    label: 'View entities as Gamma',
    description:
      'Lets the holder open any entity on the platform, including its registration details and investor positions.',
    group: 'entity',
    plane: 'gamma',
    sensitive: false,
  },
  EntityReview: {
    label: 'Review an entity',
    description: 'Lets the holder approve, reject, block, unblock or restore an entity.',
    group: 'entity',
    plane: 'gamma',
    sensitive: false,
  },
  EntityManageProviderStatus: {
    label: 'Grant or revoke deal provider status',
    description:
      'Lets the holder decide which entities may list offers on the deal marketplace as providers.',
    group: 'entity',
    plane: 'gamma',
    sensitive: true,
  },
  EntityDelete: {
    label: 'Delete an entity',
    description: 'Lets the holder delete an entity. This cannot be undone from the product.',
    group: 'entity',
    plane: 'gamma',
    sensitive: false,
  },
  ResendInvitations: {
    label: 'Resend and revoke invitations',
    description:
      'Lets the holder resend an entity member, entity shareholder or fund shareholder invitation, and revoke an entity member invitation that is still pending.',
    group: 'entity',
    plane: 'gamma',
    sensitive: true,
  },
  EntityUpdateSensitiveInfo: {
    label: "Edit an entity's registration details as Gamma",
    description:
      "Lets the holder change any entity's legal name, identification number, contact email, country, state, type, registration date and registered address.",
    group: 'entity',
    plane: 'gamma',
    sensitive: false,
  },
  EntityBypassUpdateApproval: {
    label: 'Bypass entity update approval',
    description:
      "Lets the holder change a live entity's logo without sending the change to Gamma for review. Only Gamma can add this to a role.",
    group: 'approval-bypass',
    plane: 'entity',
    sensitive: true,
    gammaAssignedOnly: true,
  },
  FundBypassUpdateApproval: {
    label: 'Bypass fund update approval',
    description:
      "Lets the holder change a live fund's description, marketing documents, cover image, logo, availability status and transferability without sending the change to Gamma for review. Only Gamma can add this to a role.",
    group: 'approval-bypass',
    plane: 'entity',
    sensitive: true,
    gammaAssignedOnly: true,
  },
  GammaBypassAllUpdateApproval: {
    label: 'Bypass approval on every field',
    description:
      'Lets the holder change any field of a live entity or fund that normally needs review and have it apply at once.',
    group: 'approval-bypass',
    plane: 'gamma',
    sensitive: true,
  },
  EntityViewRoles: {
    label: 'View roles',
    description:
      "Lets the holder open the entity's roles page and see each role, its permissions and who holds it.",
    group: 'roles',
    plane: 'entity',
    sensitive: true,
  },
  EntityManageRoles: {
    label: 'Manage roles',
    description:
      'Lets the holder create custom roles for the entity, change what a role can do, and delete roles.',
    group: 'roles',
    plane: 'entity',
    sensitive: true,
  },
  EntityAssignRoles: {
    label: 'Assign roles',
    description: 'Lets the holder give an entity role to a team member or take it away.',
    group: 'roles',
    plane: 'entity',
    sensitive: true,
  },
  GammaViewRoles: {
    label: 'View Gamma roles',
    description:
      'Lets the holder open the Gamma roles page and see each Gamma role, its permissions and who holds it.',
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: true,
  },
  GammaManageRoles: {
    label: 'Manage Gamma roles',
    description:
      'Lets the holder create custom Gamma roles, rename them, change what they can do and which address-book categories they reach, and delete them.',
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: true,
  },
  GammaAssignRoles: {
    label: 'Assign Gamma roles',
    description: 'Lets the holder give a Gamma role to a Gamma team member or take it away.',
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: true,
  },
  EntityApproveRoleRequests: {
    label: 'Approve role requests',
    description:
      'Lets the holder approve or reject role and permission change requests in the entity, and makes their own role changes apply at once. An approver can only approve what they hold themselves, and only an Owner can approve a change that grants role management.',
    group: 'roles',
    plane: 'entity',
    sensitive: true,
  },
  GammaApproveRoleRequests: {
    label: 'Approve Gamma role requests',
    description:
      'Lets the holder approve or reject role and permission change requests on the Gamma side, and makes their own Gamma role changes apply at once. An approver can only approve what they hold themselves, and only a Gamma super admin can approve a change that grants Gamma role management.',
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: true,
  },
  FundView: {
    label: 'View a fund',
    description:
      'Lets the holder view a fund, its team, members, participants and net asset values.',
    group: 'funds',
    plane: 'entity',
    sensitive: false,
  },
  FundManage: {
    label: 'Manage a fund',
    description:
      'Lets the holder create a fund, edit it, submit it for review, maintain its participants and net asset values, and rename its files.',
    group: 'funds',
    plane: 'entity',
    sensitive: false,
  },
  FundManageTeam: {
    label: 'Manage a fund team',
    description: "Lets the holder invite, edit and remove a fund's members and their invitations.",
    group: 'funds',
    plane: 'entity',
    sensitive: false,
  },
  FundAdminView: {
    label: 'View funds as Gamma',
    description:
      'Lets the holder open every fund on the platform, including funds they are not a member of.',
    group: 'funds',
    plane: 'gamma',
    sensitive: false,
  },
  FundReview: {
    label: 'Review a fund',
    description:
      'Lets the holder approve, reject, block, unblock or restore a fund, and mark its net asset value data as verified by Gamma.',
    group: 'funds',
    plane: 'gamma',
    sensitive: false,
  },
  FundDelete: {
    label: 'Delete a fund',
    description: 'Lets the holder delete a fund. This cannot be undone from the product.',
    group: 'funds',
    plane: 'gamma',
    sensitive: false,
  },
  FundCloseFund: {
    label: 'Close a fund',
    description: "Lets the holder set a fund's availability status to Closed.",
    group: 'funds',
    plane: 'entity',
    sensitive: false,
  },
  NoteModerate: {
    label: 'Moderate fund notes',
    description:
      'Lets the holder delete any note on a fund feed and change who can see any shared note.',
    group: 'funds',
    plane: 'gamma',
    sensitive: false,
  },
  NoteViewGammaInternal: {
    label: 'View Gamma-internal fund notes',
    description:
      'Lets the holder see Gamma-team notes on a fund feed and the share-link click counts behind them.',
    group: 'funds',
    plane: 'gamma',
    sensitive: false,
  },
  FundUpdateName: {
    label: 'Rename a fund as Gamma',
    description: 'Lets the holder change the name of any fund on the platform.',
    group: 'funds',
    plane: 'gamma',
    sensitive: false,
  },
  FundEditLive: {
    label: 'Edit a live fund',
    description:
      'Lets the holder change the terms, documents, imagery and narrative of a fund that is already approved. Those changes still go through Gamma review.',
    group: 'funds',
    plane: 'entity',
    sensitive: false,
  },
  InvestorViewCompliance: {
    label: 'View investor compliance data',
    description: "Lets the holder view an investor's KYC record and questionnaire answers.",
    group: 'investing',
    plane: 'entity',
    sensitive: false,
  },
  GlobalAdminCrossEntityAccess: {
    label: 'Act across every entity',
    description:
      "Lets a Gamma session reach any entity's data and actions, not only the entities the holder belongs to. It widens other permissions rather than adding an action of its own.",
    group: 'admin',
    plane: 'gamma',
    sensitive: true,
  },
  ReferralAdminView: {
    label: 'View referral data as Gamma',
    description:
      "Lets the holder open any introducer's dashboard and the Gamma views of introducers and fund referrals.",
    group: 'referral',
    plane: 'gamma',
    sensitive: false,
  },
  ReferralAdminManage: {
    label: 'Manage introducers',
    description:
      'Lets the holder create an introducer, attribute a referral by hand, and pause or unpause an introducer.',
    group: 'referral',
    plane: 'gamma',
    sensitive: false,
  },
  ReferralFeeReports: {
    label: 'Manage referral fee reports',
    description: 'Lets the holder upload and submit an introducer fee report.',
    group: 'referral',
    plane: 'gamma',
    sensitive: false,
  },
  ChatView: {
    label: 'View chat',
    description: 'Lets the holder read chat threads and their messages, and mark a thread read.',
    group: 'chat',
    plane: 'entity',
    sensitive: false,
  },
  ChatParticipate: {
    label: 'Participate in chat',
    description:
      'Lets the holder start threads and topics, send, edit and delete messages, manage participants, and archive a thread.',
    group: 'chat',
    plane: 'entity',
    sensitive: false,
  },
  ChatViewAllTopics: {
    label: 'View all chat topics',
    description:
      'Lets the holder open every chat topic, not only the topics their roles are granted.',
    group: 'chat',
    plane: 'entity',
    sensitive: true,
  },
  ChatSendAsGammaDesk: {
    label: 'Send chat as Gamma Desk',
    description:
      'Lets the holder send chat messages under the Gamma Desk identity rather than their own.',
    group: 'chat',
    plane: 'gamma',
    sensitive: false,
  },
  ChatModerateMessages: {
    label: 'Moderate chat messages',
    description:
      "Lets the holder delete other people's messages in any thread, open private threads for moderation, and make a private thread visible to all its participants.",
    group: 'chat',
    plane: 'gamma',
    sensitive: false,
  },
  ViewAndManageGammaEvents: {
    label: 'Manage all events',
    description:
      'Lets the holder see and edit every event on the platform, whoever hosts it, from the events administration pages.',
    group: 'events',
    plane: 'gamma',
    sensitive: false,
  },
  ViewAndManageOwnEvents: {
    label: 'Host own events',
    description:
      'Lets the holder create events and manage the ones they host. Events hosted by others stay out of reach.',
    group: 'events',
    plane: 'gamma',
    sensitive: false,
  },
  GammaManageEventsAccess: {
    label: 'Decide who can host events',
    description:
      'Lets the holder choose, from the Gamma dashboard, which people may host their own events.',
    group: 'events',
    plane: 'gamma',
    sensitive: true,
  },
  GammaTeamView: {
    label: 'View the Gamma team',
    description: 'Lets the holder view the Gamma team dashboard and its members.',
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: false,
  },
  GammaTeamManage: {
    label: 'Manage the Gamma team',
    description:
      "Lets the holder invite, edit and remove Gamma team members. Changing a member's roles also needs Assign Gamma roles.",
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: false,
  },
  GammaTeamAssignSuperAdmin: {
    label: 'Assign the Gamma super admin',
    description:
      'Lets the holder make someone the Gamma super admin or remove them, and lifts every role-administration safeguard for the holder. Only the Gamma super admin role carries it; no role can be given it.',
    group: 'gamma-team',
    plane: 'gamma',
    sensitive: true,
    gammaAssignedOnly: true,
  },
  AdminConsoleView: {
    label: 'Open the Gamma dashboard',
    description: 'Unlocks the Gamma dashboard home with its overview numbers and user statistics.',
    group: 'admin',
    plane: 'gamma',
    sensitive: true,
  },
  AdminTeamActivityView: {
    label: 'View team activity',
    description:
      'Lets the holder see the contact-history activity of every Gamma team member on the Gamma dashboard, not only their own.',
    group: 'admin',
    plane: 'gamma',
    sensitive: true,
  },
  AdminTeamActivityManage: {
    label: 'Manage team activity goals',
    description:
      'Lets the holder set and clear the activity goals of Gamma team members on the team activity dashboard.',
    group: 'admin',
    plane: 'gamma',
    sensitive: false,
  },
  AdminMaintenance: {
    label: 'Run maintenance jobs',
    description:
      'Lets the holder start the one-off housekeeping jobs from the admin tools: data backfills, the fund slug migration, fund approval-status and director-membership syncs, chat participant enrichment, referral recalculation and bulk test emails.',
    group: 'admin',
    plane: 'gamma',
    sensitive: false,
  },
  SigningDocumentsView: {
    label: 'View signing documents',
    description:
      'Lets the holder open their own signing documents, plus the documents of the entity they are currently acting for, and see where each one stands.',
    group: 'investing',
    plane: 'gamma',
    sensitive: false,
  },
  SigningDocumentsManage: {
    label: 'Manage signing documents',
    description:
      'Lets the holder prepare the signing agreement for a document and retrieve it once it exists.',
    group: 'investing',
    plane: 'gamma',
    sensitive: false,
  },
  InvestmentSubscriptionManageOwn: {
    label: 'Invest through the subscription wizard',
    description:
      "Lets the holder make their own investments: start a subscription, confirm eligibility, sign the agreement, attach documents, choose a payment method, confirm the transfer, or cancel. It never reaches another person's subscription.",
    group: 'investing',
    plane: 'gamma',
    sensitive: false,
  },
  InternalLookup: {
    label: 'Read internal lookup data',
    description:
      'Lets the holder search the internal records of users, entities, funds, investors, portfolios, files, signing documents and due-diligence pack requests.',
    group: 'admin',
    plane: 'gamma',
    sensitive: false,
  },
  DealManage: {
    label: 'Manage deals',
    description:
      'Lets the holder create and edit deal companies and offers, and activate, close or fill an offer.',
    group: 'deals',
    plane: 'entity',
    sensitive: false,
  },
  DealDelete: {
    label: 'Delete deals',
    description: 'Lets the holder delete a deal company or offer.',
    group: 'deals',
    plane: 'entity',
    sensitive: false,
  },
  DealAdminView: {
    label: 'View deals as Gamma',
    description:
      "Lets the holder open every provider's companies and offers in the Gamma deal views, plus the demand board.",
    group: 'deals',
    plane: 'gamma',
    sensitive: false,
  },
  DealAdminManage: {
    label: 'Manage deals as Gamma',
    description:
      "Lets the holder edit and delete any provider's offer, set its confidence score, rename a provider's company, and create, edit and remove demand entries.",
    group: 'deals',
    plane: 'gamma',
    sensitive: false,
  },
  AddressBookView: {
    label: 'View address book',
    description: 'Lets the holder see the contacts and categories in the address book.',
    group: 'address-book',
    plane: 'entity',
    sensitive: false,
  },
  AddressBookManage: {
    label: 'Manage address book',
    description:
      'Lets the holder add, edit and delete contacts and categories in the address book.',
    group: 'address-book',
    plane: 'entity',
    sensitive: false,
  },
  AddressBookViewAllCategories: {
    label: 'View all address book categories',
    description:
      'Lets the holder open every category of the address book and see every contact in it, not only the categories their roles are granted.',
    group: 'address-book',
    plane: 'entity',
    sensitive: true,
  },
  AddressBookReadAnyContacts: {
    label: 'Read any address book as Gamma',
    description:
      'Lets the holder open the address book of any entity or user on the platform, not only their own.',
    group: 'address-book',
    plane: 'gamma',
    sensitive: false,
  },
  KanbanItemView: {
    label: 'View the deal pipeline',
    description:
      'Lets the holder open the Pipeline tab on the Deals page and read its cards. The investing board on the Gamma dashboard uses the same permission.',
    group: 'deals',
    plane: 'gamma',
    sensitive: false,
  },
  KanbanManage: {
    label: 'Manage the deal pipeline',
    description:
      'Lets the holder add, move and edit pipeline cards and their invoice rows, write their own notes on a card, and remove cards they added themselves. Covers moving cards on the Gamma dashboard investing board as well.',
    group: 'deals',
    plane: 'gamma',
    sensitive: false,
  },
  KanbanAdmin: {
    label: 'Delete deal pipeline cards and notes',
    description:
      'Lets the holder delete any card on the deal pipeline or the Gamma dashboard investing board, and remove pipeline notes other people wrote.',
    group: 'deals',
    plane: 'gamma',
    sensitive: false,
  },
  EntityInvestmentBoard: {
    label: 'View and move the investing board',
    description:
      "Lets the holder open the entity's investing board under Portfolio and move its entries between stages.",
    group: 'investing',
    plane: 'entity',
    sensitive: false,
  },
  ContactImport: {
    label: 'Import contacts',
    description:
      'Lets the holder connect an external contact source and import its contacts into the address book.',
    group: 'address-book',
    plane: 'gamma',
    sensitive: false,
  },
};
